import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { playWelcomeMelody } from '../utils/SoundManager';

function WelcomePage() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [userGender, setUserGender] = useState('');
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // الحصول على بيانات المستخدم من localStorage
    const name = localStorage.getItem('userName') || 'زائرنا الكريم';
    const gender = localStorage.getItem('userGender') || 'male';
    setUserName(name);
    setUserGender(gender);
    
    // تشغيل موسيقى الترحيب الجميلة
    playWelcomeMelody();
    
    // تأخير ظهور المحتوى للتأثير البصري
    setTimeout(() => setShowContent(true), 300);
  }, []);

  const handleContinue = () => {
    navigate('/profile-setup');
  };

  const handleInstallApp = () => {
    // PWA install prompt
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt();
    }
  };

  // تحديد النص حسب الجنس
  const getSpouseText = () => {
    if (userGender === 'male') {
      return 'الزوجة الصالحة';
    } else {
      return 'الزوج الصالح';
    }
  };

  const getGreeting = () => {
    if (userGender === 'male') {
      return 'أخي الكريم';
    } else {
      return 'أختي الكريمة';
    }
  };

  return (
    <div className="page-container islamic-pattern" style={{ background: 'linear-gradient(135deg, #E0F7FA 0%, #F5F5F5 100%)' }}>
      <div className="card fade-in-scale" style={{ 
        maxWidth: '500px', 
        width: '100%', 
        padding: '40px 32px',
        textAlign: 'center',
        opacity: showContent ? 1 : 0,
        transform: showContent ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.6s ease-out',
        borderRadius: '24px',
        boxShadow: '0 20px 60px rgba(0, 137, 123, 0.15)'
      }}>
        
        {/* شعار وِداد */}
        <h1 style={{ 
          fontSize: '36px', 
          background: 'linear-gradient(135deg, #FF6B9D, #00897B)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '8px',
          fontFamily: "'Tajawal', sans-serif",
          fontWeight: '800'
        }}>
          مرحباً بك في وِداد
        </h1>

        {/* اسم المستخدم */}
        <h2 style={{ 
          fontSize: '26px', 
          color: 'var(--primary)', 
          marginBottom: '24px',
          fontFamily: "'Tajawal', sans-serif",
          fontWeight: '700',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}>
          <span>{userName}</span>
          <span className="heartbeat" style={{ fontSize: '28px' }}>💕</span>
        </h2>

        {/* رسالة الدعاء */}
        <div style={{ 
          background: 'linear-gradient(135deg, rgba(0, 180, 162, 0.08), rgba(32, 178, 170, 0.08))',
          padding: '24px 20px',
          borderRadius: '16px',
          marginBottom: '24px',
          border: '2px solid rgba(0, 180, 162, 0.15)'
        }}>
          <p style={{ 
            fontSize: '17px', 
            color: 'var(--text-dark)', 
            lineHeight: '2.2',
            fontFamily: "'Amiri', serif",
            margin: 0,
            textAlign: 'center'
          }}>
            {getGreeting()} <strong style={{ color: '#00897B' }}>{userName}</strong>
            <br/>
            نسأل الله العظيم أن يوفقك في رحلتك نحو السعادة الزوجية
            <br/>
            وأن يرزقك <strong style={{ color: '#00897B' }}>{getSpouseText()}</strong>
            <br/>
            {userGender === 'male' ? 'التي تكمل نصف دينك' : 'الذي يكمل نصف دينك'}
            <span className="floating" style={{ display: 'inline-block', marginRight: '8px' }}>🤲</span>
          </p>
        </div>

        {/* الخطوات التالية */}
        <div style={{ 
          background: 'var(--light-bg)',
          padding: '20px',
          borderRadius: '16px',
          marginBottom: '24px',
          textAlign: 'right',
          border: '1px solid var(--border-color)'
        }}>
          <h3 style={{ 
            fontSize: '16px', 
            color: '#00897B', 
            marginBottom: '16px',
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '6px'
          }}>
            <span>الخطوات التالية:</span>
            <span>✨</span>
          </h3>
          <ul style={{ 
            listStyle: 'none', 
            padding: 0, 
            margin: 0,
            fontSize: '15px',
            color: 'var(--text-dark)',
          }}>
            <li style={{ 
              padding: '10px 0', 
              borderBottom: '1px solid var(--border-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <span>أكمل ملفك الشخصي بمعلومات صادقة</span>
              <span>📝</span>
            </li>
            <li style={{ 
              padding: '10px 0', 
              borderBottom: '1px solid var(--border-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <span>ابحث عن شريك حياتك المناسب</span>
              <span>🔍</span>
            </li>
            <li style={{ 
              padding: '10px 0', 
              borderBottom: '1px solid var(--border-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <span>تواصل باحترام وأدب</span>
              <span>💬</span>
            </li>
            <li style={{ 
              padding: '10px 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <span>نسأل الله التوفيق والسداد</span>
              <span>💍</span>
            </li>
          </ul>
        </div>

        {/* زر تثبيت التطبيق */}
        <button 
          onClick={handleInstallApp}
          className="btn btn-glow"
          style={{ 
            width: '100%',
            background: 'linear-gradient(135deg, #9C27B0, #7B1FA2)',
            color: 'white',
            fontSize: '16px',
            padding: '14px 24px',
            borderRadius: '12px',
            marginBottom: '12px',
            border: 'none',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}
        >
          <span>📲</span>
          <span>تثبيت التطبيق</span>
        </button>

        {/* زر المتابعة */}
        <button 
          onClick={handleContinue}
          data-testid="continue-to-profile-btn"
          className="btn btn-glow ripple"
          style={{ 
            width: '100%',
            background: 'linear-gradient(135deg, #00897B, #00B4A2)',
            color: 'white',
            fontSize: '18px',
            padding: '16px 32px',
            borderRadius: '12px',
            boxShadow: '0 8px 25px rgba(0, 137, 123, 0.35)',
            border: 'none',
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}
        >
          <span>✨</span>
          <span>ابدأ إعداد ملفك الشخصي</span>
        </button>

        {/* نص تحفيزي */}
        <p style={{ 
          marginTop: '24px', 
          fontSize: '14px', 
          color: 'var(--text-light)',
          fontStyle: 'italic',
          lineHeight: '1.8'
        }}>
          "وَمِنْ آيَاتِهِ أَنْ خَلَقَ لَكُم مِّنْ أَنفُسِكُمْ أَزْوَاجًا لِّتَسْكُنُوا إِلَيْهَا"
        </p>
      </div>
    </div>
  );
}

export default WelcomePage;
